import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatCardComponent } from './stat-card/stat-card.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { DataGridComponent } from './data-grid/data-grid.component';
import { DatePickerComponent } from './date-picker/date-picker.component';

/**
 * Shared presentational components used across feature modules (AppModule's own
 * declarations, plus other lazily-declared modules like ReportsModule). Angular only
 * lets a component be declared once, so anything reused across module boundaries has
 * to be declared+exported here rather than directly in AppModule.
 */
@NgModule({
  declarations: [
    StatCardComponent,
    SearchInputComponent,
    DataGridComponent,
    DatePickerComponent
  ],
  imports: [
    CommonModule,
    DateInputsModule,
    MatTooltipModule
  ],
  exports: [
    StatCardComponent,
    SearchInputComponent,
    DataGridComponent,
    DatePickerComponent
  ]
})
export class AdminCommonModule { }
